/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getChallenges = 'challenges-data';
export const getChallengesUsersLeaderboard = 'challenges-users-leaderboard';
export const getChallengesTeamsLeaderboard = 'challenges-teams-leaderboard';

export const useGetChallenges = (token: string) => {
    return useQuery([getChallenges, token], () => coreService.challengesApi.getChallenges(token), {
        enabled: !!token,
        staleTime: Infinity
    });
};

export const useGetChallengeUsersLeaderboard = (
    token: string,
    enableQuery: boolean,
    challengeUuid?: string,
    teamUuid?: string
) => {
    return useQuery(
        [getChallengesUsersLeaderboard, challengeUuid, teamUuid],
        () => coreService.challengesApi.getChallengesUsersLeaderboard(token, challengeUuid, teamUuid),
        {
            enabled: Boolean(token) && !enableQuery,
            staleTime: 5 * 60 * 1000
        }
    );
};

export const useGetChallengeTeamsLeaderboard = (token: string, challengeUuid?: string) => {
    return useQuery(
        [getChallengesTeamsLeaderboard, challengeUuid],
        () => coreService.challengesApi.getChallengesTeamsLeaderboard(token, challengeUuid),
        {
            enabled: Boolean(token),
            staleTime: 5 * 60 * 1000
        }
    );
};
